const isDataURL = (s) => {
  const regex =
    // eslint-disable-next-line no-useless-escape
    /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

  return !!s.match(regex);
};

export default isDataURL;
